import * as ReactRouter from 'react-router-dom'
import * as ReactRedux from 'react-redux'
import * as React from 'react'

import * as Common from '@rushplay/common'

import * as Promotions from './promotions'
import { BannerCarousel } from './banner-carousel'
import { Divider } from './divider'
import { LiveCasinoCategory } from './live-casino-category'
import { LiveCasinoNavigation } from './live-casino-navigation'
import { SearchPage } from './search-page'

function LiveCasino() {
  const location = ReactRouter.useLocation()
  const lobbyBannerPromotions = ReactRedux.useSelector(state =>
    Promotions.getLobbyBannerPromotions(state.promotions, 'live-casino')
  )
  const showBanner = location.pathname !== '/casino/search'

  return (
    <Common.Box
      flexBasis="0"
      flexGrow="1"
      flexShrink="1"
      overflowX="hidden"
      pt={[1, 2]}
      pb={[5, 2]}
      mx="auto"
      maxWidth="1440px"
    >
      {showBanner ? (
        <Common.Box>
          <BannerCarousel banners={lobbyBannerPromotions} />
        </Common.Box>
      ) : null}
      <ReactRouter.Route path="/live-casino/:gameType?">
        <Common.Box px={[1, 2]} pb={[1, 2]}>
          <LiveCasinoNavigation />
          <Common.Space pt={0}>
            <Divider />
          </Common.Space>
        </Common.Box>
      </ReactRouter.Route>
      <ReactRouter.Switch>
        <ReactRouter.Route path="/live-casino/search" component={SearchPage} />
        <ReactRouter.Route path="/live-casino/:category">
          <LiveCasinoCategory />
        </ReactRouter.Route>
      </ReactRouter.Switch>
    </Common.Box>
  )
}

// For @loadable/components
export default LiveCasino
